import { useId } from 'react';
import type { InputHTMLAttributes } from 'react';
import styles from './TextInput.module.css';

export type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
};

export function TextInput({ label, error, id, className, ...rest }: TextInputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const errorId = `${inputId}-error`;
  return (
    <div className={styles['field']}>
      {label !== undefined && (
        <label className={styles['label']} htmlFor={inputId}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={[styles['input'], error !== undefined ? styles['invalid'] : '', className]
          .filter(Boolean)
          .join(' ')}
        aria-invalid={error !== undefined ? true : undefined}
        aria-describedby={error !== undefined ? errorId : undefined}
        {...rest}
      />
      {error !== undefined && (
        <span id={errorId} className={styles['error']} role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
